var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-2xl my-3 text-secondary-text"},[_c('the-text-view',{attrs:{"value":_vm.articleItem.news_headline}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }